import { useEffect } from "react";

const SITE_URL = "https://thefoodgala.com";
const DEFAULT_OG = `${SITE_URL}/icon-512.png`;

function upsertMeta(attr, value, content) {
    let el = document.head.querySelector(`meta[${attr}="${value}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Lightweight client-side SEO updater.
 * Sets per-route <title>, meta description, canonical URL, and OpenGraph/Twitter tags.
 *
 * Props:
 *   title:        page title (browser tab + search-result heading)
 *   description:  150–160 char meta description (search-result snippet)
 *   path:         route path (e.g. "/services") — used to build canonical + og:url
 *   image:        optional OG share image (defaults to the brand icon)
 */
export default function Seo({ title, description, path = "/", image = DEFAULT_OG }) {
    useEffect(() => {
        const fullUrl = `${SITE_URL}${path}`;
        document.title = title;

        upsertMeta("name", "description", description);
        upsertLink("canonical", fullUrl);

        // OpenGraph
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "The Food Gala");
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", fullUrl);
        upsertMeta("property", "og:image", image);
        upsertMeta("property", "og:locale", "en_IN");

        // Twitter
        upsertMeta("name", "twitter:card", "summary_large_image");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);
        upsertMeta("name", "twitter:image", image);
    }, [title, description, path, image]);

    return null;
}
